// extracted by mini-css-extract-plugin
export var cartContainer = "_pb-4";
export var gray = "_pb-1";
export var itemContainer = "_pb-2";
export var itemDetails = "_pb-3";
export var strong = "_pb-0";